import { dew as _undiscriminatedUnionDew } from "./undiscriminatedUnion";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.undiscriminatedUnion = void 0;
  var undiscriminatedUnion_1 = _undiscriminatedUnionDew();
  Object.defineProperty(exports, "undiscriminatedUnion", {
    enumerable: true,
    get: function () {
      return undiscriminatedUnion_1.undiscriminatedUnion;
    }
  });
  return exports;
}